import {
  OnInit,
  Input,
  Output,
  EventEmitter,
  Component,
  ViewEncapsulation
} from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import { environment } from '@env/environment';
@Component({
  selector: 'iw-button-download-review-modify',
  templateUrl: './button-download-review-modify.component.html',
  styleUrls: ['./button-download-review-modify.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ButtonDownloadReviewModifyComponent implements ViewCell, OnInit {
  // entrada del valor del boton
  @Input() value: any;
  // entrada de la fila a la cual se le dio click
  @Input() rowData: any;
  // variable que controla el boton de previzualizar
  previewButton = environment.previsulizacionDocumentos;
  // Indica si la tarea esta finaliza o no
  taskStatus = true;
  // salida del evento del click
  @Output() save: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
  }

  /**
   * Emite el evento retornando el id del documento
   *
   * @memberof ButtonDownloadReviewModifyComponent
   */
  onDownload() {
    if (this.rowData.id) {
      const data = {
        'accion': 'download',
        'data': this.rowData.id
      };
      this.save.emit(data);
    } else {
      const error = {
        'accion': 'error',
        'menssage': 'Aun no se a subido un archivo para este documento'
      };
      this.save.emit(error);
    }
  }

/**
   * Emite el evento retornando el id del documento
   *
   * @memberof ButtonDownloadReviewModifyComponent
   */
 onPreview() {
  if (this.rowData.id) {
    const data = {
      'accion': 'preview',
      'data': this.rowData.id
    };
    this.save.emit(data);
  } else {
    const error = {
      'accion': 'error',
      'menssage': 'Aun no se a subido un archivo para este documento'
    };
    this.save.emit(error);
  }
}

}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/button-download-review-modify/button-download-review-modify.component.ts